export type ContextLike = {
  id?: string;
  name?: string;
  agentID?: string;
};

export const normalizeContextSlug = (value?: string): string => {
  const source = String(value || '')
    .trim()
    .toLowerCase();
  if (!source) return '';

  return source
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const getContextSlug = (context?: ContextLike): string => {
  return (
    normalizeContextSlug(context?.id) ||
    normalizeContextSlug(context?.name) ||
    normalizeContextSlug(context?.agentID) ||
    'context'
  );
};

export const getContextHomePath = (context?: ContextLike): string => {
  return `/contexts/${getContextSlug(context)}`;
};

